var React = require('react');

function PersonIconInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#949494"},[React.createElement("path",{"d":"m13.3145 14.5464c3.5168 0 6.3678-3.0754 6.3678-6.86918 0-3.79376-2.851-6.869206-6.3678-6.869206-3.51679 0-6.36772 3.075446-6.36772 6.869206 0 3.79378 2.85093 6.86918 6.36772 6.86918z","key":0}),React.createElement("path",{"d":"m26.6288 23.4773c.0027-.6573-.1784-1.3015-.5218-1.8551-.3433-.5537-.8342-.9934-1.4138-1.2664-3.5881-1.6107-7.466-2.4194-11.3788-2.3729-3.91277-.0465-7.79075.7622-11.37879 2.3729-.57959.273-1.070512.7127-1.413846 1.2664-.343334.5536-.52449237 1.1978-.52173294 1.8551v4.8075h26.62876894z","key":1})]));
}

PersonIconInline.defaultProps = {"fill":"none","height":"29","viewBox":"0 0 27 29","width":"27"};

module.exports = PersonIconInline;

PersonIconInline.default = PersonIconInline;
